import { clsx } from 'clsx';
import React from 'react';

import type { SaveListItem } from '../../../../types/save-types.js';

import { frontendConfig } from '../../../../../core/system/config/frontend.server.js';

type Props = {
  handleOnClick: (groupItem: SaveListItem) => void;
  isSaved: boolean;
  item: SaveListItem;
  isFact?: boolean;
  disabled?: boolean;
  condensed?: boolean;
};

const SaveButton: React.FC<Props> = ({
  handleOnClick,
  isSaved,
  item,
  isFact,
  disabled = false,
  condensed = false,
}) => {
  const heartIconLink = `${
    frontendConfig.cdnUrlInternal
  }/vink/images/icons/bookmark${isSaved ? '-saved' : '-bold'}.svg`;

  const saveStatus = isSaved ? 'Lagret' : isFact ? 'Lagre saken' : 'Lagre';

  return (
    <button
      className={clsx('save', { condensed })}
      onClick={() => handleOnClick(item)}
      disabled={disabled}
      {...(condensed ? { 'aria-label': 'Lagre artikkel' } : {})}
    >
      {!condensed && (
        <span className={clsx('save-text', { bold: isSaved })}>
          {saveStatus}
        </span>
      )}
      <img src={heartIconLink} alt="lagre" />
    </button>
  );
};

export default SaveButton;
